import { useEffect, useState } from 'react';

interface Props {
  onStay: () => void;
  onLogout: () => void;
  countdownSeconds: number;
}

export function IdleWarningModal({ onStay, onLogout, countdownSeconds }: Props) {
  const [remaining, setRemaining] = useState(countdownSeconds);

  useEffect(() => {
    setRemaining(countdownSeconds);
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) { clearInterval(interval); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [countdownSeconds]);

  return (
    <div style={s.overlay} role="dialog" aria-modal="true" aria-labelledby="idle-title">
      <div style={s.card}>
        <div style={s.icon}>⏱️</div>
        <h2 id="idle-title" style={s.title}>Still there?</h2>
        <p style={s.body}>
          You've been inactive for a while. For your security, you'll be logged out in{' '}
          <strong style={{ color: remaining <= 10 ? '#EF4444' : '#4F46E5' }}>{remaining}s</strong>.
        </p>
        <div style={s.countdownBar}>
          <div style={{ ...s.countdownFill, width: `${(remaining / countdownSeconds) * 100}%`, background: remaining <= 10 ? '#EF4444' : '#4F46E5' }} />
        </div>
        <div style={s.actions}>
          <button style={s.stayBtn} onClick={onStay} autoFocus>
            Keep me logged in
          </button>
          <button style={s.logoutBtn} onClick={onLogout}>
            Log out now
          </button>
        </div>
      </div>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(15,23,42,0.65)',
    backdropFilter: 'blur(4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '16px',
  },
  card: {
    background: '#fff', borderRadius: '16px',
    maxWidth: '380px', width: '100%',
    padding: '32px 28px', textAlign: 'center',
    boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
  },
  icon: { fontSize: '44px', marginBottom: '12px' },
  title: { fontSize: '20px', fontWeight: 800, color: '#1E1B4B', margin: '0 0 10px' },
  body: { fontSize: '14px', color: '#475569', lineHeight: 1.6, margin: '0 0 20px' },
  countdownBar: {
    height: '6px', background: '#E2E8F0', borderRadius: '3px',
    overflow: 'hidden', marginBottom: '24px',
  },
  countdownFill: {
    height: '100%', borderRadius: '3px',
    transition: 'width 1s linear, background 0.3s',
  },
  actions: { display: 'flex', flexDirection: 'column', gap: '10px' },
  stayBtn: {
    padding: '12px', borderRadius: '10px', border: 'none',
    background: 'linear-gradient(135deg, #4F46E5, #7C3AED)',
    color: '#fff', fontSize: '14px', fontWeight: 700, cursor: 'pointer',
  },
  logoutBtn: {
    padding: '10px', borderRadius: '10px',
    border: '1px solid #E2E8F0', background: 'transparent',
    color: '#64748B', fontSize: '13px', fontWeight: 500, cursor: 'pointer',
  },
};
